import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from './../services/authorization.service';
import { TokenResponse } from '@openid/appauth';
import { environment } from '../../environments/environment';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-loginping',
  templateUrl: './loginping.component.html'
})
export class LoginpingComponent implements OnInit {

  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private userService: UserService
  ) {
    // debugger;
  }

  ngOnInit() {
    const token = sessionStorage.getItem('momaccesstoken');

    // ✅ Already logged in
    if (token) {
      this.router.navigate(['/dashboard']);
      return;
    }

    // ✅ Start Ping login
    if (environment.isPingEnable) {
      this.startPingLogin();
    }
  }

  private startPingLogin() {
    this.authorizationService.authorize();

    this.authorizationService.tokenResponse().subscribe({
      next: (res: TokenResponse | null) => {
        if (res?.accessToken) {
          sessionStorage.setItem('momaccesstoken', res.accessToken);

          // debugger;
           const user = this.userService.getUserInfo(); // or from API if needed

            if (user) {
              localStorage.setItem('userinfo', JSON.stringify(user));
            }

          // ✅ SUCCESS
          this.router.navigate(['/dashboard']);
        } else {
          this.router.navigate(['/extlogin']);
        }
      },
      error: () => {
        this.router.navigate(['/extlogin']);
      }
    });
  }
}